export const SET_GROUPS = 'SET_GROUPS';
export const UPSERT_GROUP = 'UPSERT_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP';
